// @core/api/endpoints/license/report_usage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReportUsageRequest,
  ReportUsageResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Report usage snapshot
 * Submits a usage snapshot for license compliance tracking. Reports active users, storage, tenants, and per-product metrics.
 */
export async function ReportUsage(
  license_id: string,
  data: ReportUsageRequest,
  options?: RequestOptions
): Promise<ReportUsageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/usage`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<ReportUsageResponse>(requestPath, data, requestOptions);
}
